import React, { useEffect, useState } from 'react';
import api from '../Api';

export default function LaporanHandlingTime() {
  const [perJenis, setPerJenis] = useState([]);
  const [summary, setSummary] = useState(null);

  const [wilayahList, setWilayahList] = useState([]);
  const [wilayahId, setWilayahId] = useState('');

  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData) {
      setUserRole(userData.role_id);
    }

    fetchWilayah();
    fetchData();
  }, []);

  // ================= FETCH WILAYAH =================
  const fetchWilayah = async () => {
    try {
      const res = await api.get('/wilayah');
      setWilayahList(res.data || []);
    } catch (err) {
      console.error('Gagal load wilayah', err);
    }
  };

  // ================= FETCH DATA =================
  const fetchData = async (custom = {}) => {
    try {
      setLoading(true);

      const res = await api.get('/report/drbsd-json', {
        params: custom,
      });

      setPerJenis(res.data.per_jenis || []);
      setSummary(res.data.summary || null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWilayah();
    fetchData();
  }, []);

  // ================= FILTER =================
  const handleFilter = () => {
    const params = {};

    if (from && to) {
      params.from = from;
      params.to = to;
    }

    if (wilayahId) {
      params.wilayah_id = wilayahId;
    }

    fetchData(params);
  };

  const handleReset = () => {
    setFrom('');
    setTo('');
    setWilayahId('');
    fetchData();
  };

  // ================= EXPORT EXCEL =================
  const handleExportExcel = async () => {
    try {
      setExportLoading(true);

      const params = {};

      if (from && to) {
        params.from = from;
        params.to = to;
      }

      if (wilayahId) {
        params.wilayah_id = wilayahId;
      }

      const response = await api.get('/report/drbsd', {
        params,
        responseType: 'blob',
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'laporan_handling_time.xlsx');

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export gagal', err);
      alert('Gagal export excel');
    } finally {
      setExportLoading(false);
    }
  };

  // ================= RENDER =================
  return (
    <div className="container py-4 laporan-bsd">
      <h3 className="fw-bold mb-3">Laporan Handling Time</h3>

      {/* FILTER */}
      <div className="row g-2 mb-4">
        {userRole !== 2 && (
          <div className="col-md-3">
            <label className="form-label">Wilayah</label>
            <select className="form-select" value={wilayahId} onChange={(e) => setWilayahId(e.target.value)}>
              <option value="">Semua Wilayah</option>
              {wilayahList.map((w) => (
                <option key={w.kd_wilayah} value={w.kd_wilayah}>
                  {w.nama_wilayah}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="col-md-2">
          <label className="form-label">From</label>
          <input type="date" className="form-control" value={from} onChange={(e) => setFrom(e.target.value)} />
        </div>

        <div className="col-md-2">
          <label className="form-label">To</label>
          <input type="date" className="form-control" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>

        <div className="col-md-5 d-flex align-items-end gap-2">
          <button className="btn btn-primary" onClick={handleFilter}>
            Filter
          </button>

          <button className="btn btn-secondary" onClick={handleReset}>
            Reset
          </button>
          <button className="btn btn-success" onClick={handleExportExcel} disabled={exportLoading}>
            {exportLoading ? 'Generating...' : 'Generate Excel'}
          </button>
        </div>
      </div>

      {loading && <p>Loading...</p>}

      {/* ================= PER JENIS ================= */}
      {perJenis.map((jenisItem, idx) => {
        const ratio = jenisItem.problem > 0 ? Math.round((jenisItem.closed / jenisItem.problem) * 100) : 0;

        return (
          <div key={idx} className="mb-5">
            <h5 className="judul-jenis text-uppercase">JENIS PENGADUAN {jenisItem.jenis}</h5>

            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Kategori Pengaduan</th>
                  <th>Problem</th>
                  <th>Closed</th>
                  <th>On Progress</th>
                  <th>Handling Time Average (Jam)</th>
                </tr>
              </thead>

              <tbody>
                {jenisItem.detail.map((row, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td className="text-start">{row.category}</td>
                    <td>{row.problem}</td>
                    <td>{row.closed}</td>
                    <td>{row.on_progress}</td>
                    <td>{row.avg_hours ? Number(row.avg_hours).toFixed(2) : '-'}</td>
                  </tr>
                ))}

                <tr className="row-total">
                  <td colSpan={2}>JUMLAH</td>
                  <td>{jenisItem.problem}</td>
                  <td>{jenisItem.closed}</td>
                  <td>{jenisItem.on_progress}</td>
                  <td>{jenisItem.avg_hours ? Number(jenisItem.avg_hours).toFixed(2) : '-'}</td>
                </tr>

                <tr className="row-ratio">
                  <td colSpan={4} className="text-end">
                    RASIO PENYELESAIAN PENGADUAN
                  </td>
                  <td>{ratio}%</td>
                  <td>JAM</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}

      {/* ================= SUMMARY ================= */}
      {summary && (
        <div className="mt-4">
          <table className="table table-bordered text-center">
            <tbody>
              <tr className="fw-bold">
                <td>SUMMARY</td>
                <td>{summary.total_issue}</td>
                <td>{summary.solved}</td>
                <td>{summary.unsolved}</td>
                <td>{Number(summary.avg_hour).toFixed(0)}</td>
              </tr>

              <tr className="fw-bold">
                <td colSpan={3} className="text-end">
                  RASIO PENYELESAIAN PENGADUAN
                </td>
                <td>{summary.solving_ratio_percent}%</td>
                <td>JAM</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
